export default "__VITE_ASSET__DzfDCxo8__"